import { render } from "./ClientMangerCard.vue?vue&type=template&id=459f9318&scoped=true&ts=true"
import script from "./ClientMangerCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientMangerCard.vue?vue&type=script&setup=true&lang=ts"

import "./ClientMangerCard.vue?vue&type=style&index=0&id=459f9318&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-459f9318"],['__file',"resources/js/vue/domain/invoice/components/cards/ClientMangerCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "459f9318"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('459f9318', __exports__)) {
    api.reload('459f9318', __exports__)
  }
  
  module.hot.accept("./ClientMangerCard.vue?vue&type=template&id=459f9318&scoped=true&ts=true", () => {
    api.rerender('459f9318', render)
  })

}


export default __exports__